import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { TCaseWorkflow } from "../data-access/types";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import ExpandText from "src/chamber/features/manageApplication/components/ExpandText";
import i18n from "src/shared/services/languages/i18n";
import useCustomMaterialTable from "src/shared/hooks/useCustomMaterialTable";
import getTableLang from "src/shared/services/languages/MaterialReactTable/getTableLang";
import { Paper } from "@mui/material";

export default function CaseWorkflowHistory({
  workflowHistory,
}: {
  workflowHistory: TCaseWorkflow[];
}) {
  const { t } = useTranslation();

  const columns = useMemo<MRT_ColumnDef<TCaseWorkflow>[]>(
    () => [
      {
        header: t("Ημερομηνία μετάβασης ελέγχου"),
        accessorKey: "date_created",
        accessorFn: (originalRow) => {
          return `${format(new Date(originalRow.date_created), "dd/MM/yyyy HH:mm:ss")}`;
        },
      },
      {
        header: t("Από"),
        accessorKey: "fromUser",
      },
      {
        header: t("Μήνυμα"),
        accessorKey: "message",
        accessorFn: (originalRow) => {
          return <ExpandText message={originalRow.message} />;
        },
      },
      {
        header: t("Πρός"),
        accessorKey: "toUser",
      },
    ],
    [i18n.language],
  );

  const table = useCustomMaterialTable({
    columns: columns,
    data: workflowHistory ?? [],
    localization: getTableLang(),
    enableColumnActions: false,
    enableTopToolbar: false,
    enableSorting: false,
  });

  return (
    <Paper sx={{ padding: "1rem" }}>
      <h3>{t("Ιστορικό διεκπεραίωσης")}</h3>
      <MaterialReactTable table={table} />
    </Paper>
  );
}
